import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = Vue.prototype.$storage.getUniversal('isAuthenticated')
  const needsInitialSetup = localStorage.getItem('needsInitialSetup')
  const hasCompletedSetup = Vue.prototype.$storage.getUniversal('hasCompletedSetup')

  if (to.meta.private && !isAuthenticated) {
    next({ name: 'Login' })
    window.location.reload()
    localStorage.clear()
  } else if (to.meta.public && isAuthenticated) {
    next({ name: 'Dashboard' })
  } else if (
    isAuthenticated &&
    needsInitialSetup === 'true' &&
    !hasCompletedSetup &&
    to.name !== 'SetupPage'
  ) {
    next({ name: 'SetupPage' })
  } else if (
    isAuthenticated &&
    to.name === 'SetupPage' &&
    (!needsInitialSetup || needsInitialSetup !== 'true' || hasCompletedSetup)
  ) {
    next({ name: 'Dashboard' })
  } else {
    next()
  }
})

export default router
